import React, { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ROUTES_V2_PATHS } from 'constants/route-constants';
import { ongoingDeliveriesV2Selector } from 'selectors/new-history-selectors';
import { useIntervalOngoingFetch } from 'views/v2/new-booking-table-page/common-hooks.js';
import BookAgainSection from './book-again-section';
import OngoingSections from './ongoing-sections';

const OrderSummarize = () => {
  const history = useHistory();
  const { deliveries } = useSelector(ongoingDeliveriesV2Selector);

  useIntervalOngoingFetch('home');

  const goToBookingsTab = useCallback(
    () => {
      history.push({
        pathname: ROUTES_V2_PATHS.bookings,
      });
    },
    [history],
  );

  return (
    <Fragment>
      {!deliveries ? null : (
        <OngoingSections goToBookingsTab={goToBookingsTab} />
      )}
      <BookAgainSection goToBookingsTab={goToBookingsTab} />
    </Fragment>
  );
};

export default OrderSummarize;
